import { type RequestPayload, router } from "@inertiajs/core";
import { DocumentForm } from "../../../components/document/general/DocumentForm";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import type { Apprentice } from "../../../models/apprentice";
import { documents_path } from "../../../routes";

type DocumentCreateProps = {
  apprentices: Apprentice[];
};

export default function DocumentCreate({ apprentices }: DocumentCreateProps) {
  const { pathWithYearContext } = useYearContext();

  return (
    <ContentShell title="Neues Dokument" onBack={() => router.get(pathWithYearContext(documents_path))}>
      <DocumentForm
        apprentices={apprentices}
        saveButtonLabel="Erstellen"
        onSubmit={(values: RequestPayload) =>
          router.post(pathWithYearContext(documents_path), values, {
            forceFormData: true,
          })
        }
      />
    </ContentShell>
  );
}
